module.exports = __webpack_public_path__ + "static/3-f87c962ef608ed1de2a9b20e8869510b.jpg";